/** InsCoder WANG.J 2026-07-21 B + Multi-use native carousel progress state. **/
document.querySelectorAll('.cust-community-multi[data-community-cards]').forEach((section) => {
  const track = section.querySelector('[data-card-track]');
  const cards = [...section.querySelectorAll('.cust-community-multi__card')];
  const segments = [...section.querySelectorAll('[data-card-progress]')];

  if (!track || cards.length === 0 || segments.length === 0) return;

  const update = () => {
    const activeIndex = cards.reduce((closest, card, index) => (
      Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[closest].offsetLeft - track.scrollLeft) ? index : closest
    ), 0);

    segments.forEach((segment, index) => segment.classList.toggle('is-active', index === activeIndex));
  };

  track.addEventListener('scroll', update, { passive: true });
  update();
});
/** InsCoder WANG.J 2026-07-21 E + Multi-use native carousel progress state. **/
